var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "top",
    on: {
      "click": _vm.backClick
    }
  }, [_c('img', {
    attrs: {
      "src": "https://imagessl.edujia.com/A-1ed71af7_20230804162525.png",
      "crossorigin": "Anonymous"
    }
  }), _c('div', [_vm._v("返回")])]), _c('div', {
    staticClass: "list"
  }, [_vm._l(_vm.list, function (item, idx) {
    return _c('div', {
      key: 'show' + item.val
    }, [item.type == 'img' ? _c('img', {
      staticClass: "imgItem",
      attrs: {
        "src": item.val,
        "crossorigin": "Anonymous"
      },
      on: {
        "click": function ($event) {
          return _vm.imgClick(idx);
        }
      }
    }) : item.type == 'file' ? _c('div', {
      staticClass: "fileItem",
      on: {
        "click": function ($event) {
          return _vm.fileClick(idx);
        }
      }
    }, [_c('img', {
      staticClass: "fileItemImg",
      attrs: {
        "src": item.fileIcon
      }
    }), _c('div', {
      staticClass: "fileItemDiv"
    }, [_vm._v(_vm._s(item.title))]), _vm.miniCodeUrl ? _c('div', {
      staticClass: "filePoster",
      attrs: {
        "id": 'filePoster' + item.val
      }
    }, [_c('div', {
      staticClass: "filePosterT"
    }, [_c('img', {
      attrs: {
        "src": item.fileIcon
      }
    }), _c('div', [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "filePosterB"
    }, [_c('img', {
      staticClass: "filePosterBImg",
      attrs: {
        "src": 'data:image/png;base64,' + _vm.miniCodeUrl
      }
    }), _c('div', [_vm._v("扫一扫查看文件")])])]) : _vm._e()]) : item.type == 'audio' ? _c('div', {
      staticClass: "fileItem",
      on: {
        "click": function ($event) {
          return _vm.audioClick(idx);
        }
      }
    }, [_c('img', {
      staticClass: "fileItemImg",
      attrs: {
        "src": item.fileIcon
      }
    }), _c('div', {
      staticClass: "fileItemDiv"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "filePoster",
      attrs: {
        "id": 'audioPoster' + item.id
      }
    }, [_c('div', {
      staticClass: "filePosterT"
    }, [_c('img', {
      attrs: {
        "src": item.fileIcon
      }
    }), _c('div', [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "filePosterB"
    }, [_c('div', {
      staticClass: "filePosterBImg",
      attrs: {
        "id": 'audioQr' + item.id
      }
    }), _c('div', [_vm._v("扫一扫查看文件")])])])]) : _vm._e()]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }]
  }, _vm._l(_vm.list, function (item, idx) {
    return _c('img', {
      key: item.val,
      staticClass: "imgItemOrg",
      attrs: {
        "id": item.val + idx,
        "src": item.val,
        "crossorigin": "Anonymous"
      },
      on: {
        "click": function ($event) {
          return _vm.imgClick(idx);
        }
      }
    });
  }), 0)], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };